import { cn } from '~/shared/lib/cn'
import { Text, Tooltip } from '~/shared/ui'

export function USIndicator({
  className,
  align,
  tooltip,
}: {
  className?: string
  align?: 'start'
  tooltip?: string
}) {
  return (
    <Tooltip
      content={tooltip || 'US Reviewers Only'}
      align={align}
    >
      <Text
        className={cn(
          'border-primary-main text-text-link bg-surface-lowest cursor-pointer rounded-sm border px-1.5 py-0.5',
          className,
        )}
        appearance="CAPTION"
      >
        US
      </Text>
    </Tooltip>
  )
}
